import { SafeUrl } from '@angular/platform-browser';


export function getFileUrlFromToken(token: string | null): string | null {
   if (!token) {
      return null;
   }
   return `files?id=${token}`;
}

export function isFileUrl(url: string | SafeUrl | null, fileUrlPrefix: string) {
   return (
      url != null &&
      (typeof url !== 'string' ||
         (url.startsWith(fileUrlPrefix) && url.length > fileUrlPrefix.length) ||
         // per the spec, blob URLs always start with 'blob:', see https://www.w3.org/TR/FileAPI/#url-model
         url.startsWith('blob:'))
   );
}
